import {
  Kamoku,
  HasId,
  ResponseSettingItem,
  KeieiJokyoKmkTypeType,
  HospitalClinicKbnType, keieiJokyoKmkTypeType
} from '@/repositories/keiei-joho/data'
import { CorporationInfoData, FacilityInfoData } from '@/repositories/commons/corporationInfoRepository'

export type ResponseKeieiJokyoSettingItem = HasId & {
  hospitalClinicKbn: HospitalClinicKbnType
  kmkName: string;
  kmkType: KeieiJokyoKmkTypeType;
  isRequiredSettingHospital: boolean;
  isRequiredSettingClinic: boolean;
  setting: ResponseSettingItem;
}

export type ResponseKeieiJokyoSetting = {
  kamokuSources: Kamoku[],
  items: ResponseKeieiJokyoSettingItem[]
}

export type CorporationInfoPick = Pick<CorporationInfoData, 'corporateName' | 'medicalCorporationNumber' | 'corporationNumber'>
export type FacilityInfoPick = Pick<FacilityInfoData,
  'facilityKey' | 'displayOrder' | 'hospitalClinicKbn' | 'hospitalClinicName' | 'hasBedOutpatientMgmtNumber' | 'bedOutpatientMgmtNumber' |
  'hasMedicalInstitutionCode' | 'medicalInstitutionCode' | 'executiveCount' | 'staffCount' | 'prefecture' |
  'municipality' | 'townArea' | 'secondaryMedicalArea' | 'taxAccountingMethod' | 'primarySpecialty1' | 'primarySpecialty2' | 'primarySpecialty3'>
export type FacilityInfoPickPick = Pick<FacilityInfoPick, 'facilityKey' | 'displayOrder' | 'hospitalClinicName' | 'hospitalClinicKbn'>

export interface HasKin {
  kin: number | null;
}

export type KeieiJokyoKmkType = HasKin & {
  kmkName: string;
  kmkType: KeieiJokyoKmkTypeType;
  isRequiredSettingHospital: boolean;
  isRequiredSettingClinic: boolean;
  exportKmkName: string;
}

export function initializeKeieiJokyoKmk (): KeieiJokyoKmkType {
  return {
    kmkName: '',
    kmkType: keieiJokyoKmkTypeType.IgyoShueki,
    isRequiredSettingHospital: false,
    isRequiredSettingClinic: false,
    exportKmkName: '',
    kin: 0
  }
}

export type ResponseKeieiJokyoExportLayout = {
  corporationInfo: CorporationInfoPick,
  facilityInfo: FacilityInfoData,
  kmkTypes: KeieiJokyoKmkType[]
}
